import { decimal, money } from '@/js/shared/billables/decimal';

export function calculateRetainerTotals({ items, payments }) {
  const total = money(items.reduce((sum, item) => sum.plus(money(item.total)), decimal(0)));
  const balance = total.minus(money(payments || 0));

  return {
    subtotal: total.toFixed(2),
    shipping: '0.00',
    total: total.toFixed(2),
    balance: (balance.gt('0') ? balance : decimal(0)).toFixed(2),
  };
}
